import {
    FormControl,
    InputLabel,
    MenuItem,
    Select
} from '@mui/material';

const WidgetSelect = ({ label, value, onChange, options }) => (
    <FormControl fullWidth margin="dense" size="small">
        <InputLabel>{label}</InputLabel>
        <Select value={value} label={label} onChange={onChange}>
            <MenuItem value="">Seleccione una opción...</MenuItem>

            {options?.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                </MenuItem>
            ))}
        </Select>
    </FormControl>
);

export default WidgetSelect;
